import { get, isEmpty, map, orderBy, filter } from "lodash";
import { useState, useEffect, useRef } from "react";

// import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

import Image from "grandus-lib/components-atomic/image/Image";
import ProductCard from "components/product/card/ProductCard";
import styles from "./crossSale.module.scss";
import { Carousel } from "antd";

const CrossSale = ({ data }) => {
  if (isEmpty(data)) {
    return "";
  }

  const carouselsContainerRef = useRef();
  const [active, setActive] = useState(0);

  useEffect(() => {
    let container = document.getElementById("container");
    let sliders = carouselsContainerRef.current.querySelectorAll(".productCarousel");
    
    let getStyle = function (e, styleName) {
      let styleValue = "";

      if (document.defaultView && document.defaultView.getComputedStyle) {
        styleValue = document.defaultView
          .getComputedStyle(e, "")
          .getPropertyValue(styleName);
      } else if (e.currentStyle) {
        styleName = styleName.replace(/\-(\w)/g, function (strMatch, p1) {
          return p1.toUpperCase();
        });
        styleValue = e.currentStyle[styleName];
      }
      return styleValue;
    };

    function recalculateSliderContainer() {
      setTimeout(() => {
        let marginLeft = getStyle(container, "margin-left").replace("px", "");
        marginLeft = parseInt(marginLeft) + 15 + "px";

        sliders.forEach((item) => {
          item.style.marginLeft = marginLeft;
          item.style.width = "calc(100% - " + marginLeft + ")";
          // item.firstChild.style.width = "100%";
        });
      }, 100);
    }

    if (typeof container != "undefined" && container != null) {
      recalculateSliderContainer();

      window.addEventListener("resize", function () {
        recalculateSliderContainer();
      });
    }
  }, [active]);

  const PrevArrow = ({ onClick }) => {
    return (
      <button
        className={`${styles.carouselArrow} ${styles.arrowPrev}`}
        onClick={onClick}
      >
        <img src="https://instance5.admin.grandus.sk/files/attachment/2020-11/6469/5f4cb5/arrow-left.svg" />
      </button>
    );
  };

  const NextArrow = ({ onClick }) => {
    return (
      <button
        className={`${styles.carouselArrow} ${styles.arrowNext}`}
        onClick={onClick}
      >
        <img src="https://instance5.admin.grandus.sk/files/attachment/2020-11/6472/09fa27/arrow-right.svg" />
      </button>
    );
  };

  const settings = {
    dots: true,
    infinite: false,
    // speed: 500,
    slidesToScroll: 1,
    slidesToShow: 6,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
        },
      },
    ],
  };

  const carousels = filter(orderBy(data, ["priority"], ["desc"]), (rule) => {
    if (get(rule, "hash")) {
      return false;
    }

    if (isEmpty(get(rule, "products", []))) {
      return false;
    }

    return true;
  });

  return (
    <section
      ref={carouselsContainerRef}
      className={[
        styles.productSliderWrapper,
        "favouriteProducts",
        "productSlider",
      ].join(" ")}
    >
      <div className="custom-container">
        <div className="sliderTitle hasCategories">
          <h2>Odporúčame dokúpiť</h2>
          <div className="categories">
            {map(carousels, (rule, i) => {
              const { name, photo = {} } = rule;
              return (
                <a
                  key={"carousel-button" + i}
                  className={`button secondary ${i == active ? "active" : ""} ${
                    styles.tabButton
                  }`}
                  onClick={(e) => {
                    setActive(i);
                  }}
                >
                  {get(photo, "id") ? (
                    <Image
                      photo={photo}
                      size={"30x30"}
                      type={"jpg"}
                      className={styles.tabImage}
                    />
                  ) : (
                    ""
                  )}{" "}
                  {name}
                </a>
              );
            })}
          </div>
        </div>
      </div>

      {map(carousels, (rule, i) => {
        if (active != i) {
          return "";
        }

        return (
          <div key={"carousel-" + i}>
            <Carousel
              {...settings}
              //responsive={productSliderResponsive}
              // swipeable={true}
              // draggable={false}
              // infinite={false}
              // ssr={true}
              // arrows={false}
              // showDots={true}
              // partialVisible={true}
              // customButtonGroup={<SliderArrowsGroup />}
              // containerClass='productCarousel'
              className="productCarousel"
              arrows
            >
              {get(rule, "products", []).map((product, index) => {
                return (
                  <div key={`products-${product.id}-${index}`}>
                    <ProductCard
                      {...product}
                      options={{
                        style: { wrapperClasses: [styles?.productCard] },
                      }}
                    />
                  </div>
                );
              })}
            </Carousel>
          </div>
        );
      })}
    </section>
  );
};

export default CrossSale;
